import PropTypes from 'prop-types';
import { Field } from 'formik';
import { Select } from 'chakra-react-select';
import FormikFormControl from './FormikFormControl';

function SelectAvatarStyleInput({
  name,
  label,
  options,
  placeholder,
  helperText,
  isRequired,
  ...rest
}) {
  return (
    <Field name={name}>
      {({ field, form }) => (
        <FormikFormControl
          label={label}
          helperText={helperText}
          errors={form.errors[name]}
          touched={form.touched[name]}
          isRequired={isRequired}
          {...rest}
        >
          <Select
            size="sm"
            placeholder={placeholder}
            options={options}
            onChange={(selectedOption) => {
              form.setFieldValue(name, selectedOption?.value || '');
            }}
            value={
              options.find((option) => option.value === field?.value) || null
            }
          />
        </FormikFormControl>
      )}
    </Field>
  );
}

SelectAvatarStyleInput.defaultProps = {
  placeholder: 'Select an option',
  helperText: null,
  isRequired: false,
};

SelectAvatarStyleInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  isRequired: PropTypes.bool,
};

export default SelectAvatarStyleInput;
